"use client"

import * as ToastPrimitives from "@radix-ui/react-toast"
import { useToast } from "@/ui/shared/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastTitle,
  ToastViewport,
} from "@/ui/shared/components/toast"

export function Toaster() {
  const { toasts } = useToast()

  // Group toasts by position
  const toastsByPosition = toasts.reduce((acc, toast) => {
    const position = toast.position || "top-middle"
    if (!acc[position]) {
      acc[position] = []
    }
    acc[position].push(toast)
    return acc
  }, {} as Record<string, typeof toasts>)

  return (
    <ToastPrimitives.Provider>
      {Object.entries(toastsByPosition).map(([position, positionToasts]) => (
        <ToastViewport key={position} position={position as any}>
          {positionToasts.map(function ({ id, title, description, action, ...props }) {
            return (
              <Toast key={id} {...props}>
                <div className="grid gap-1">
                  {title && <ToastTitle>{title}</ToastTitle>}
                  {description && (
                    <ToastDescription>{description}</ToastDescription>
                  )}
                </div>
                {action}
                <ToastClose />
              </Toast>
            )
          })}
        </ToastViewport>
      ))}
    </ToastPrimitives.Provider>
  )
}
